var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"id":_vm.id,"value":_vm.value,"options":_vm.options,"label":"name","reduce":_vm.reduce,"placeholder":"Selecciona un grupo de categoría"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }